import { useUserRole } from './hooks';
import { ManagerNavigation, RegularNavigation, SubscriptionNavigation } from './roles';

// TODO remove canShow, put a bunch of ifs in one AllNavigation and
// let it handle all roles + remove this abstracted userRole which is clunky
export const AuthenticatedNavigation = () => {
  const userRole = useUserRole();

  return (
    <>
      {userRole === 'subscription' && <SubscriptionNavigation />}
      {userRole === 'manager' && <ManagerNavigation />}
      {userRole === 'regular' && <RegularNavigation />}
    </>
  );
};
